import React, { FC, Fragment, useMemo } from "react";
import { logger } from "cayo.ui";
import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { FormProps } from "@cayo/shared/components/Form/types";
import useService from "@cayo/shared/services/hooks/useService";
import useTypeAnnotations from "../GlobalHooks/type-annotations.hook";
import useForm from "./hooks/useForm";

const ReadonlyODataContainer: FC<{ object?: Entity }> = ({ object }) => {
  const actionBuilder = useService("actionBuilder");
  const { getIconAnnotation } = useTypeAnnotations();

  const formProps = useMemo<FormProps>(() => {
    const result = { items: [] };
    return {
      type: "json-form",
      ...result,
      actionBuilder,
      object,
      showDynamicProps: true,
      disabled: true,
      getIconAnnotation,
    };
  }, [object]);

  const { renderer, model, isFormInitializing } = useForm(formProps, object!);

  logger.debug(model);
  if (isFormInitializing) {
    return <Fragment />;
  }

  return <Fragment>{renderer()}</Fragment>;
};

export default ReadonlyODataContainer;
